import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    height: 100%;
  }
  body {
    background: rgb(25,100,168);
background: -moz-linear-gradient(0deg, rgba(25,100,168,1) 45%, rgba(0,145,252,0.8183648459383753) 100%, rgba(2,0,36,1) 100%);
background: -webkit-linear-gradient(0deg, rgba(25,100,168,1) 45%, rgba(0,145,252,0.8183648459383753) 100%, rgba(2,0,36,1) 100%);
background: linear-gradient(0deg, rgba(25,100,168,1) 45%, rgba(0,145,252,0.8183648459383753) 100%, rgba(2,0,36,1) 100%);
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#1964a8",endColorstr="#020024",GradientType=1);
    background-size: cover;
    margin: 0;
    padding: 0 20px;
    display: flex;
    justify-content: center;
  }
  * {
    font-family: 'Catamaran', sans-serif;
    box-sizing: border-box;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  > p {
    color: #fff;
  }
  .score {
    color: #fff;
    font-size: 2rem;
    margin: 0;
  }
  h1 {
    font-family: Fascinate Inline;
    background-image: linear-gradient(180deg, #fff, #87f1ff);
    font-weight: 400;
    background-size: 100%;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-background-clip: text;
    -moz-text-fill-color: transparent;
    filter: drop-shadow(2px 2px #0085a3);
    font-size: 70px;
    text-align: center;
    margin: 20px;
  }
  .start, .next {
    cursor: pointer;
    background: linear-gradient(180deg, #ffffff, #ffcc91);
    border: 2px solid #d38558;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    height: 40px;
    margin: 20px 0;
    padding: 0 40px;
  }

`;